import { useEffect } from "react";

export const useOnMount = (onMountFunc) => {
  useEffect(() => {
    onMountFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useOnMount;